import { Card, Divider, Row } from 'antd'

import { EpidemiologyCaseForm058E_SymptomsSection } from 'src/api/requests'
import { useLocales } from 'src/locales'

import { useStyles } from '../styles'

import { CaseSymptomsDetailsCard } from './CaseSymptomsDetailsCard'
import { GastroIntenstinalSymptomsDetailsCard } from './GastroIntenstinalSymptomsDetailsCard'
import { GeneralSymptomsDetailsCard } from './GeneralSymptomsDetailsCard'
import { HospitalizationSymptomsDetailsCard } from './HospitalizationSymptomsDetailsCard'
import { NeurologicalSymptomsDetailsCard } from './NeurologicalSymptomsDetailsCard'
import { OcularSymptomsDetailsCard } from './OcularSymptomsDetailsCard'
import { OtherSymptomsDetailsCard } from './OtherSymptomsDetailsCard'
import { PainsSymptomsDetailsCard } from './PainsSymptomsDetailsCard'
import { RespiratorySymptomsDetailsCard } from './RespiratorySymptomsDetailsCard'
import { SkinAndMucousSymptomsDetailsCard } from './SkinAndMucousSymptomsDetailsCard'
import { UrinarySymptomsDetailsCard } from './UrinarySymptomsDetailsCard'
import { VaccineSymptomsDetailsCard } from './VaccineSymptomsDetailsCard'

type Props = {
  symptoms: EpidemiologyCaseForm058E_SymptomsSection
}

export const EpidemiologySymptomsDetailsCard = ({ symptoms }: Props) => {
  const { t } = useLocales()

  const { styles } = useStyles()

  return (
    <Card title={t('epidemiology.symptoms_title')}>
      <Row gutter={[24, 24]}>
        <GeneralSymptomsDetailsCard symptoms={symptoms} />

        <Divider className={styles.divider} />

        <SkinAndMucousSymptomsDetailsCard symptoms={symptoms} />

        <Divider className={styles.divider} />

        <NeurologicalSymptomsDetailsCard symptoms={symptoms} />

        <Divider className={styles.divider} />

        <OcularSymptomsDetailsCard symptoms={symptoms} />

        <Divider className={styles.divider} />

        <RespiratorySymptomsDetailsCard symptoms={symptoms} />

        <Divider className={styles.divider} />

        <GastroIntenstinalSymptomsDetailsCard symptoms={symptoms} />

        <Divider className={styles.divider} />

        <UrinarySymptomsDetailsCard symptoms={symptoms} />

        <Divider className={styles.divider} />

        <PainsSymptomsDetailsCard symptoms={symptoms} />

        <Divider className={styles.divider} />

        <OtherSymptomsDetailsCard symptoms={symptoms} />

        <Divider className={styles.divider} />

        <HospitalizationSymptomsDetailsCard symptoms={symptoms} />

        <Divider className={styles.divider} />

        <VaccineSymptomsDetailsCard symptoms={symptoms} />

        <Divider className={styles.divider} />

        <CaseSymptomsDetailsCard symptoms={symptoms} />
      </Row>
    </Card>
  )
}
